<template>
  <!-- READ ONLY MODE -->

  <div class="option-section" v-if="mode === 'VIEW'">
    <div class="question-container">
      <span class="step" v-if="showStep">Step {{ question.stepSequence }}</span>
      <p class="question_body ql-editor p-0" v-html="question.formattedBody"></p>
    </div>
    <div class v-if="question.hasBodyImage">
      <div class v-for="(img, index) in question.bodyImages" :key="index">
        <img :src="img.imageUrl" alt class="wid300" />
      </div>
    </div>

    <SiteFacingMultiChoiceMulti v-if="isMulti" :question="question" is-read-only />
    <SiteFacingMultiChoiceSingle v-if="isSingle" :question="question" is-read-only />
  </div>

  <!-- EDIT MODE -->

  <div v-else-if="mode == 'EDIT'" class>
    <div class="p-0">
      <div @click="isAddHelpEnabled = !isAddHelpEnabled" class="th-activity-question-type-multichoice-edit">
        <span
          class="add-help-text"
          :style="{
            color: isAddHelpEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
          }"
        >
          Add Help
        </span>
      </div>
      <quill-editor class="bg-white mt-30" v-model="question.formattedBody" :disabled="question.type === 'Default'" :options="commonProps.editorOptionForQuestion"></quill-editor>
    </div>
    <!-- help content -->
    <div v-if="isAddHelpEnabled">
      <h5 class="answer">Help</h5>
      <quill-editor class="bg-white mt-40" v-model="question.helpContent" :options="editorOptionForHelp" v-on:change="helpCharacterLimitValidation($event)"></quill-editor>
    </div>

    <div class="p-0 mt-20 row" v-if="question.hasBodyImage">
      <div v-for="bodyImageoption in question.bodyImages" :key="bodyImageoption.id">
        <div class="col-lg-2 pl-0 pr-20" :style="bodyImageoption.imageUrl == null ? 'border:1px solid #d3dfe4' : ''" v-if="question.bodyImages.length !== 0">
          <img alt="img" v-if="bodyImageoption.imageUrl && bodyImageoption.imageUrl != null" class="img_size mar-top15" :src="bodyImageoption.imageUrl" />
        </div>
        <div class="col-lg-3 col-md-3 mt-20 file_container">
          <span class="file_container_text upload_btn">Upload</span>
          <input
            type="file"
            :id="'file_upload_' + bodyImageoption.sequence"
            class="form-control-file"
            @click="uploadImageClick($event)"
            @change="
              uploadBodyImage($event, bodyImageoption, 'file_upload_' + bodyImageoption.sequence);
              return false;
            "
          />
          <a class="color_red cursor_pointer fs-12 pt-10" v-if="question.bodyImages.length !== 0" v-on:click="deleteImageBodyQuestion(bodyImageoption)">Remove</a>
          <span class v-if="question.bodyImages.length == 0">
            Large images will automatically resize to fit the width of the phone
          </span>
        </div>
      </div>
    </div>

    <h5 class="answer">Answers</h5>
    <div class="row form-group" v-for="(option, index) in question.options" :key="index">
      <div v-if="option.enabled !== false">
        <div :class="index > 1 ? 'col-sm-11 p-0' : 'col-sm-11 p-0'">
          <div v-if="activityDetails.customParticipantMessaging" v-on:click="deleteQuestionOptionMessageItem(question.options, index)" class="th-activity-question-type-multichoice-edit mr-35 pt-1">
            <span
              class="add-message-text"
              :style="{
                color: option.isAddMessageEnabled ? 'rgba(0, 0, 0, 0.2)' : ''
              }"
            >
              Add Message
            </span>
          </div>
          <quill-editor class="bg-white mt-30 mb-10 quill-score" v-model="option.formattedBody" :options="editorOptionForAnswers"></quill-editor>
        </div>
        <div class="col-lg-1 p-0 score_cls">
          <h5 class="score_text">Value</h5>
          <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="option.score">
            <input value="999" v-model.number="option.score" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" type="number" class="integer-plus-minus-input" />
          </integer-plusminus>
        </div>
        <div v-if="option.isAddMessageEnabled && activityDetails.customParticipantMessaging" class="row add_message_div">
          <div class="col-md-11 p-0">
            <h5 class="mt-10">Message</h5>
            <quill-editor class="bg-white mb-10 quill-score" v-model="option.messageBody" :options="editorOptionForMessage" @change="helpCharacterLimitValidation"></quill-editor>
          </div>
          <div class="col-md-1 p-0">
            <button class="btn btn-link color_red pl-0 pt-35" v-on:click="deleteQuestionOptionMessageItem(question.options, index)">
              <img alt="delete" src="static/img/delete.svg" />
            </button>
          </div>
        </div>
        <div :class="[index > 1 ? '' : ' mb-20']" class="col-lg-12 p-0" v-if="question.isColorCodeEnabled">
          <colorPicker @colorCodeChange="option.colorCoding.color = $event" :colorValue="option && option.colorCoding && option.colorCoding.color" :warningMsg="option && option.colorCoding && option.colorCoding.warningMessage" @warningMessageChange="option.colorCoding.warningMessage = $event" />
        </div>
        <div class="col-sm-2 p-0" v-if="index > 1">
          <button class="btn btn-link color_red" v-on:click="checkBranchingNRemoveOption(index)" v-if="index > 1">
            Remove
          </button>
        </div>
      </div>
    </div>
    <div class="add_another_answer">
      <a class="color_1f95f2" v-on:click="addAnotherAnswer()">Add another answer</a>
    </div>

    <div class="row">
      <div class="pt-15 fs-15 mb-20">
        <label class>
          <input type="checkbox" v-model="question.isDisplayOtherOptionContentField" />
          <span class="text-align">Add an "Other" answer option or comment field</span>
        </label>
      </div>
      <template v-if="question.isDisplayOtherOptionContentField">
        <div class="row" v-if="question.isDisplayOtherOptionContentField">
          <div class="col-md-4">
            <div class="ml-10">
              <b>Label</b>
            </div>
            <div class="ml-10 mb-20 pl-0">
              <b-form-input type="text" class="fs-15 form-control-sm mt-10 field-h40" v-model="question.otherOptionContentField" placeholder="Other (please specify)" size="sm" @keydown.native="preventInvalidCharacters" @change="onOtherOptionContentChange"></b-form-input>
            </div>
          </div>
          <div class="col-md-4">
            <div class="ml-10 score_text">
              <b>Value</b>
            </div>
            <div class="ml-10 mb-20 pl-0 score_cls">
              <integer-plusminus :min="0" :max="999" :step="1" :vertical="false" :disabled="activityDetails && activityDetails.canScoreResponses == false" formName="score" class="score_input" v-model.number="question.otherScore">
                <input value="999" v-model.number="question.otherScore" oninput="javascript: if (this.value.length > this.maxLength) this.value = this.value.slice(0, this.maxLength);" maxlength="3" type="number" class="integer-plus-minus-input" />
              </integer-plusminus>
            </div>
          </div>
        </div>
        <div v-if="question.isDisplayOtherOptionContentField" class="ml-10 pt-15 fs-15 mb-20">
          <label class="ml-12">
            <input type="checkbox" class v-model="question.isDisplayOtherCommentSelectedField" />
            <span class="text-align">Provide comment field if "Other" is selected</span>
          </label>
        </div>
        <div class="ml-10 col-md-12" v-if="question.isDisplayOtherCommentSelectedField">
          <div>
            <b>Instructional text to display in comment field</b>
          </div>
          <div class="col-md-4 pt-5 pb-15 pl-0">
            <b-form-input type="text" class="fs-15 form-control mt-10 field-h40" v-model="question.otherCommentSelectedField" placeholder="Please describe in more details" size="sm" maxLength="255"></b-form-input>
          </div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import { IntegerPlusminus } from "vue-integer-plusminus";
import colorPicker from "../../common/color-picker";
import _ from "lodash";
import { v4 as uuidv4 } from "uuid";
import { quillEditor } from "vue-quill-editor";
import { BranchingHelper } from "@/components/activity-library/branching-helper";
import SiteFacingMultiChoiceSingle
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-single.vue";
import SiteFacingMultiChoiceMulti
  from "@/components/common/multi-choice/site-facing/site-facing-multi-choice-multi.vue";
import * as MultiChoiceService from "@/components/common/multi-choice/multi-choice-service";

export default {
  name: "ActivityStepMultichoice",
  props: {
    question: {},
    showStep: { type: Boolean },
    mode: {
      default: "VIEW"
    },
    activityDetails: {},
    commonProps: {},
    editorOptionForHelp: {
      type: Object
    }
  },
  components: {
    SiteFacingMultiChoiceMulti,
    SiteFacingMultiChoiceSingle,
    IntegerPlusminus,
    colorPicker,
    quillEditor
  },
  data() {
    return {
      editorOptionForAnswers: {
        placeholder: "Enter answer choice",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], [{ align: [] }], ["clean"]]
        }
      },
      editorOptionForMessage: {
        placeholder: "Enter custom message text",
        modules: {
          toolbar: [[{ color: [] }, { background: [] }], ["bold", "italic", "underline", "link"], [{ list: "ordered" }, { list: "bullet" }], [{ header: [1, 2, 3, 4, 5, 6, false] }], [{ indent: "-1" }, { indent: "+1" }], ["clean"]]
        }
      },
      isAddHelpEnabled: false,
      BranchingHelper: new BranchingHelper()
    };
  },
  watch: {
    isAddHelpEnabled() {
      this.question.isAddHelpEnabled = this.isAddHelpEnabled;
    }
  },
  computed: {
    isMulti() {
      return MultiChoiceService.isMulti(this.question);
    },
    isSingle() {
      return MultiChoiceService.isSingle(this.question);
    }
  },
  methods: {
    onOtherOptionContentChange(value) {
      if (typeof value === "string" && value.indexOf(":") !== -1) {
        this.question.otherOptionContentField = value.replaceAll(":", "");
        this.$forceUpdate();
      }
    },
    preventInvalidCharacters(e) {
      if (e.key === ":") {
        e.preventDefault();
      }
    },
    helpCharacterLimitValidation(event, maxCount = 250) {
      const helpContent = event.quill;
      if (event.text.length > maxCount) {
        this.$toastr.error(`Character limit cannot exceed ${maxCount}.`);
      }
      helpContent.deleteText(maxCount, helpContent.getLength());
    },
    stripHtml(content) {
      const temporalDivElement = document.createElement("div");
      temporalDivElement.innerHTML = content;
      return temporalDivElement.innerText;
    },
    checkBranchingNRemoveOption(index) {
      //Check and Remove branching if this option is a part of branching
      if (this.BranchingHelper.optionHasBranchConfigured(this.question, index)) {
        //Check if user wants to remove the branching or not
        this.BranchingHelper.optionHasBranchNCanBeRemoved().then(res => {
          if (res) {
            //Remove branching & remove option
            this.question = this.BranchingHelper.removeBranching(this.question);
            this.deleteQuestionOptionItem(index);
          }
        });
      } else {
        //Remove option
        this.deleteQuestionOptionItem(index);
      }
    },
    deleteQuestionOptionItem(index) {
      // Toggle the 'isAddMessageEnabled' property
      this.question.options[index].isAddMessageEnabled = !this.question.options[index].isAddMessageEnabled;
      // Remove the option from the array
      this.question.options.splice(index, 1);
      // Update the sequence numbers for remaining options
      this.question.options.forEach((option, ind) => {
        option.sequence = ind + 1;
      });
      // If needed, force the component to re-render
      this.$forceUpdate();
    },
    deleteQuestionOptionMessageItem(options, index) {
      this.question.options[index].isAddMessageEnabled = !this.question.options[index].isAddMessageEnabled;
      this.$forceUpdate();
    },
    addAnotherAnswer() {
      if (!this.question.options) {
        this.question.options = [];
      }
      let maxSequence = Number(_.max(_.map(this.question.options, "sequence")));
      if (!maxSequence) {
        maxSequence = this.question.options.length;
      }
      this.question.options.push({
        body: null,
        sequence: maxSequence + 1,
        nextQuestion: null,
        imageUrl: null,
        colorCoding: {
          color: "#fff",
          warningMessage: null
        },
        messageBody: null,
        isAddMessageEnabled: false
      });
      this.init();
      this.$forceUpdate();
    },
    checkQuestionValidity() {
      const question = this.question;
      const errorObj = { isValid: true };
      if (!question.formattedBody || this.stripHtml(question.formattedBody).trim() == "") {
        // return false;
        errorObj.isValid = false;
        return errorObj;
      }
      if (question.isAddHelpEnabled && (!question.hasOwnProperty("helpContent") || this.stripHtml(question.helpContent).trim() === "")) {
        errorObj.isValid = false;
        errorObj.msg = "Help text is required for this step.";
        return errorObj;
      }
      _.forEach(question.options, value => {
        const body = this.stripHtml(value.formattedBody);
        if (body.length == 0) {
          errorObj.isValid = false;
          errorObj.msg = "Answer is required.";
          return errorObj;
        }

        if (question.isColorCodeEnabled && ((value.colorCoding && value.colorCoding.color === null) || (value.colorCoding && value.colorCoding.color === "#fff"))) {
          errorObj.isValid = false;
          errorObj.msg = "Please select an alert color.";
          return errorObj;
        }

        if (body && body.length > 512) {
          errorObj.isValid = false;
          errorObj.msg = "Character limit reached.";
          return errorObj;
        }

        if (!value.formattedBody) {
          errorObj.isValid = false;
          return errorObj;
        }

        const uniqueOptionsArr = _.uniqBy(question.options, "formattedBody");
        if (uniqueOptionsArr.length < question.options.length) {
          errorObj.isValid = false;
          errorObj.notUniqueOptions = true;
          return errorObj;
        }

        if ((value.messageBody == undefined || value.messageBody.trim() == "" || value.messageBody.trim().length == 0) && value.isAddMessageEnabled) {
          errorObj.isValid = false;
          errorObj.msg = "Message text is required for this step.";
          return errorObj;
        }
      });

      if (!errorObj.isValid) {
        return errorObj;
      }

      if (question.hasBodyImage) {
        _.forEach(question.bodyImages, value => {
          if (!value.imageUrl) {
            errorObj.isValid = false;
            errorObj.msg = "Please upload an image.";
            return errorObj;
          }
        });
        if (!errorObj.isValid) {
          return errorObj;
        }
      }
      if (question.isDisplayOtherOptionContentField && (question.otherOptionContentField == null || question.otherOptionContentField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Label is required.";
        return errorObj;
      }
      if (question.isDisplayOtherOptionContentField && this.question.otherOptionId == null) {
        this.question.otherOptionId = uuidv4();
      }
      if (question.isDisplayOtherCommentSelectedField && (question.otherCommentSelectedField == null || question.otherCommentSelectedField.length == 0)) {
        errorObj.isValid = false;
        errorObj.msg = "Comment is required.";
        return errorObj;
      }
      if (!question.isDisplayOtherOptionContentField) {
        delete this.question.otherOptionId;
        delete this.question.otherOptionContentField;
        delete this.question.otherCommentSelectedField;
        question.isDisplayOtherCommentSelectedField = false;
      }
      if (!question.isDisplayOtherCommentSelectedField) {
        delete this.question.otherCommentSelectedField;
      }
      return {
        isValid: Boolean(question.sequence && question.options.length > 1)
      };
      // break;
    },

    uploadImageClick(event) {
      event.target.value = null;
    },
    uploadBodyImage(event, option, id) {
      const selectedImage = event.target.files[0];
      const input = window.document.getElementById(id);
      if (input.files[0] && this.validateImage(input.files[0]) == null) {
        this.$toastr.error("Image upload failed. Please try again.");
        event.target.value = null;
        return;
      }
      const rand = Math.random()
        .toString(36)
        .substr(2, 10);
      const imageId = option.imageId ? option.imageId : `img_id_${rand}`;

      const reader = new FileReader();
      reader.onload = e => {
        const file = {
          fileName: input.files[0].name,
          contentType: input.files[0].type,
          sequence: option.sequence,
          imageId: imageId,
          base64Code: e.target.result.split(",")[1]
        };
        this.$api.imageActivityQuestionFact(this.activityDetails.id, file).then(
          response => {
            // const optionIndex = Number(response.data.result.sequence) - 1;
            const optionIndex = _.findIndex(this.question.bodyImages, ["sequence", Number(response.data.result.sequence)]);
            this.question.bodyImages[optionIndex].imageUrl = response.data.result.imageUrl;
            this.question.bodyImages[optionIndex].imageId = response.data.result.imageId;
            this.question.bodyImages[optionIndex].sequence = response.data.result.sequence;
            this.$toastr.success("Image uploaded successfully");
            window.$('#file_upload[type="file"]').val(null);
          },
          error => {
            this.errorMsg = error.body ? error.body.message : "Error while uploading the image.";
            this.$toastr.error(this.errorMsg);
          }
        );
      };
      reader.readAsDataURL(selectedImage);
    },
    validateImage(image) {
      const isValid = image.name.match(/.(png|jpg|svg)$/i);
      return isValid;
    },
    deleteImageBodyQuestion(option) {
      let isError = false;
      if (this.question.hasBodyImage) {
        _.forEach(this.question.bodyImages, value => {
          if (!value.imageUrl) {
            this.$toastr.error("Please upload an image.");
            isError = true;
          }
        });
      }
      if (isError == false) {
        this.$api.deleteActivityOptionFact(this.activityDetails.id, option).then(
          () => {
            const optionIndex = _.findIndex(this.question.bodyImages, ["sequence", option.sequence]);
            this.question.bodyImages.splice(optionIndex, 1, {
              sequence: 1,
              imageUrl: null,
              imageId: null
            });
            this.$toastr.success("Image deleted successfully");
            window.$('#file_upload[type="file"]').val(null);
          },
          error => {
            this.errorMsg = error.body ? error.body.message : "Error while deleting the option.";
            this.$toastr.error(this.errorMsg);
          }
        );
      }
    },
    init() {
      if (!this.question.id) {
        for (let key = 0; key < this.question.options.length; key++) {
          this.$set(this.question.options[key], "score", 0);
        }
      }
    }
  },
  mounted() {
    if (!this.question.id) {
      this.$set(this.question, "isAdvancedScoring", false);
    } else {
      this.$set(this.question, "isAdvancedScoring", this.question.isAdvancedScoring);
    }
    this.init();
    this.isAddHelpEnabled = this.question.isAddHelpEnabled;
  }
};
</script>

<style scoped lang="scss">
.th-activity-question-type-multichoice-edit {
  position: relative;
  .add-help-text {
    position: absolute;
    z-index: 9;
    right: 533px;
    top: -38px;
    padding: 11.5px 13px;
    background-color: rgba(211, 223, 228, 0.5);
    font-size: 12px;
    color: #000000;
    font-weight: normal;
    line-height: 1.33;
    cursor: pointer;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;
  }

  .add-message-text {
    position: absolute;
    z-index: 9;
    right: 526.5px;
    top: -7px;
    padding: 12px 13px;
    background-color: rgba(211, 223, 228, 0.5);
    font-size: 12px;
    color: #000000;
    font-weight: normal;
    line-height: 1.33;
    cursor: pointer;
    border-top-left-radius: 3px;
    border-top-right-radius: 3px;

    @media (min-width: 1600px) {
      right: 535px;
    }
  }
}
.radio-option {
  margin: 0px;
  label {
    padding-left: 5px;
  }
}

.file_container [type="file"] {
  cursor: inherit;
  display: block;
  font-size: 20px;
  filter: alpha(opacity=0);
  width: 80px;
  height: 31px;
  max-height: 50px;
  max-width: 300px;
  opacity: 0;
  position: absolute;
  right: 0;
  text-align: right;
  top: 0px;
  left: 0px;
  z-index: 100;
}
.file_container [type="file"].language-img-file {
  cursor: inherit;
  display: block;
  filter: alpha(opacity=0);
  opacity: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto;
  height: auto;
  border: 1px solid red;
  font-size: initial;
}
.file_container {
  padding: 0px 10px 0 0;
  color: grey;
}
.file_container [type="file"] {
  cursor: pointer;
}
.file_container_text {
  background-color: #d3dfe4;
  padding: 5px;
  width: 100%;
  display: block;
  border-radius: 4px;
  text-align: center;
  color: #959fa4;
}
.img_size {
  width: 100%;
  height: 100%;
  border: 1px solid #d3dfe4;
}
.integer-plus-minus-input {
  width: 2rem;
  border: none;
}
.btn-link.color_red {
  margin-left: -8px;
}
.add_message_div {
  margin-top: -8px;
}
.activity-configurator-step-edit-mode {
  .form-group {
    margin-bottom: 20px;
    font-weight: normal;
  }
}
</style>
